import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

export class EndsWith extends Operator<string> {
  constructor() {
    super(LOGIC_OPERATOR.ENDS_WITH, z.string())
  }

  evaluate(factValue: string, comparisonValue: ComparisonValue): boolean {
    if (typeof comparisonValue === 'string') {
      return factValue.endsWith(comparisonValue)
    }

    return false
  }
}
